const statusList = [
  {
    label: 'Pesanan Dibuat',
    labelBtn: 'Assign',
    value: 'WAITING'
  },
  {
    label: 'Menunggu Konfirmasi',
    labelBtn: 'Konfirmasi',
    value: 'ASSIGNING'
  },
  {
    label: 'Pesanan Telah Terkonfirmasi',
    value: 'CONFIRM'
  },
  {
    label: 'Penjemputan',
    value: 'PICKUP'
  },
  {
    label: 'Sampai Lokasi Penjemputan',
    value: 'LOAD'
  },
  {
    label: 'Pengiriman',
    value: 'DELIVER'
  },
  {
    label: 'Sampai Lokasi Tujuan',
    value: 'UNLOAD'
  },
  {
    label: 'Barang Diterima Utuh',
    value: 'COMPLETE_FULL'
  },
  {
    label: 'Barang Diterima Toko',
    value: 'COMPLETE_IN_STORE',
  },
  {
    label: 'Barang Diterima Tidak Utuh',
    value: 'COMPLETE_HALF'
  },
  {
    label: 'Ditolak',
    value: 'COMPLETE_REJECT'
  },
  {
    label: 'Tertunda',
    value: 'ONHOLD'
  },
  {
    label: 'Dibatalkan',
    value: 'CANCEL'
  },
  {
    label: 'BA Penerimaan - Dikembalikan ke gudang Asal',
    value: 'COMPLETE_RETURN_ORIG'
  },
  {
    label: 'BA Penerimaan - Ganti lokasi tujuan',
    value: 'COMPLETE_CHANGE_DEST'
  },
  {
    label: 'Kedaluwarsa',
    value: 'EXPIRED'
  },
  {
    label: 'BA Penerimaan - Konfirmasi Shipper',
    value: 'NEED_CONFIRM'
  },

]

const statusCategory = {
  waiting: ['ASSIGNING'],
  inProcess: [
    'CONFIRM',
    'PICKUP',
    'LOAD',
    'DELIVER',
    'UNLOAD',
    'ONHOLD',
    'EXPIRED'
  ],
  completed: [
    'COMPLETE_FULL',
    'COMPLETE_HALF',
    'COMPLETE_REJECT',
    'COMPLETE_IN_STORE',
    'COMPLETE_IN_RETURN_ORIG',
    'COMPLETE_CHANGE_DEST',
    'NEED_CONFIRM',
    'CANCEL',
  ]
}

const getStatusText = function (value, isButton) {
  if (isButton && (value === 'ASSIGNING' || value === 'WAITING')) return statusList.find(i => i.value === value).labelBtn
  return statusList.find(i => i.value === value).label
}

export default {
  statusList,
  statusCategory,
  getStatusText,
}
